// Copyright 2017 Sorama B.V.

import { customElement } from "aurelia-framework";

@customElement("support-info")
export class SupportInfo {}
